import React, { useState, useEffect, useContext, useRef } from "react";
import { components } from "react-select";

import MyScheduleFeesContext from "../MyScheduleFeesContext";
import ConsultationSettingsContainer from "./ConsultationSettingsContainer";
import afterLoginApiAxios from "../../../../Util/API Calls/afterLogin";
import AddTimeRange from "./AddTimeRange";
import MyScheduleModal from "../Modals/MyScheduleModal";
import Loader from "../../../UI Component/Loader/Loader";
import useDisableHelp from "../../../../Hooks/useDisableHelp";
import "./updateSchedule.scss";
import CustomSelect from "../../../UI Component/CustomSelect/CustomSelect";
import ViewLogs from "../ViewLogs";
import { UPDATE_SCHEDULE } from "../Constants";
import { APPLICABLE_ROLE } from "../../../DashboardAppointmentsView/Constant";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../../../Util/constants";
import { C2CConsole } from "../../../../Util/Helper/C2CConsole";
import InformationBox from "../../../common/InformationBox";

export default function UpdateScheduleDetails(props) {
  const {
    handleViewSlots,
    staffDoctor,
    callProcedureApi,
    handleShowDelayMarkedPopup,
    dropdownOptionsList,
  } = props;
  const myScheduleFeesContext = useContext(MyScheduleFeesContext);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [procedure_length, setProcedureLenght] = useState();
  const [ErrorModal, setErrorModal] = useState(false);
  const [slotValue, setSlotValue] = useState({});
  const [loader, setLoader] = useState(false);
  const [disableAddBtn, setDisableAddBtn] = useState(false);
  const [consultationCounter, setConsultationCounter] = useState(0);
  const [procedureCounter, setProcedureCounter] = useState(0);
  const [addClass, setAddClass] = useState("");
  const [commonProcedure, setCommonProcedure] = useState(false);

  useDisableHelp();

  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const clinicRef = useRef(clinicId);
  const doctorRef = useRef(staffDoctor);

  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const isResourceArray = localStorage.getItem("isResourceArray");
  const doctId =
    localStorage.getItem("staff_selected_dr") &&
    JSON.parse(localStorage.getItem("staff_selected_dr"));
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  useEffect(() => {
    setDropdownOptions(myScheduleFeesContext.consultationTypes);

    C2CConsole.log(
      "myScheduleFeesContext.consultationTypes===>",
      myScheduleFeesContext.consultationTypes
    );
  }, [myScheduleFeesContext.consultationTypes]);

  //use effect to get procedure;
  useEffect(() => {
    getProcedure("");
  }, [staffDoctor, clinicId]);

  useEffect(() => {
    if (callProcedureApi) {
      getProcedure("");
    }
  }, [callProcedureApi]);

  useEffect(() => {
    if (
      clinicRef.current !== clinicId ||
      doctorRef.current?.doctor_id !== staffDoctor?.doctor_id
    ) {
      myScheduleFeesContext.setSelectedConsultationType({
        value: "0",
        id: "0",
        label: "Tele-Consult Regular",
      });
      clinicRef.current = clinicId;
      doctorRef.current = staffDoctor;
    }
  }, [clinicId, staffDoctor]);

  //function to get the procedure list
  function getProcedure(procedure_id) {
    let doctor_clinic_association = localStorage.getItem(
      LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
    );
    let staff_clinic_association = localStorage.getItem(
      LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
    );
    let api_url = "";
    let payload = {};
    if (
      (doctor_clinic_association == "true" ||
        staff_clinic_association == "true") &&
      clinicId
    ) {
      api_url = "/clinic/get-procedure";
      payload = {
        doctor_id:
          doctorRole == USER_ROLE.DOCTOR_ADMIN ||
          doctorRole == USER_ROLE.RESOURCE_ADMIN ||
          userType == APPLICABLE_ROLE.STAFF
            ? doctId
              ? doctId.doctor_id
              : staffDoctor.id
            : userId,
        clinic_id: clinicId,
      };
    } else {
      api_url = "/doctor/get-procedure";
      payload = {
        doctor_id:
          userType === APPLICABLE_ROLE.DOCTOR
            ? userId
            : doctId
            ? doctId.doctor_id
            : staffDoctor.id,
      };
    }
    setLoader(true);
    afterLoginApiAxios({
      method: "post",
      url: api_url, //"/doctor/get-procedure",
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        ...payload,
      },
    })
      .then((response) => {
        let arr =
          localStorage.getItem("isResourceArray") === "True" ||
          doctorRole === USER_ROLE.RESOURCE_CONSULTANT
            ? []
            : [...myScheduleFeesContext.consultationTypes];
        if (response.data.statusCode == 200) {
          if (response.data.procedure_details.length > 0) {
            response.data.procedure_details.map((ele) => {
              ele["value"] = ele.id;
              ele["id"] = "4";
              ele["label"] = ele.procedure_name;
              arr.push(ele);
            });
            setDropdownOptions(arr);
            setProcedureLenght(response.data.procedure_details.length);
            if (procedure_id != "") {
              let findValue = arr.find((data) => data.value == procedure_id);
              findValue = findValue ? findValue : arr[0];
              findValue &&
                myScheduleFeesContext.setSelectedConsultationType({
                  id: "4",
                  value: procedure_id,
                  label:
                    procedure_id == "4"
                      ? findValue.label
                      : findValue.procedure_name,
                  consultation_duration: findValue.consultation_duration,
                  common_procedure: findValue.common_procedure,
                });
            } else {
              myScheduleFeesContext.setSelectedConsultationType(arr[0]);
            }
          } else {
            setDropdownOptions(arr);
          }
        } else {
          if (
            localStorage.getItem("isResourceArray") === "True" ||
            doctorRole === USER_ROLE.RESOURCE_CONSULTANT
          ) {
            myScheduleFeesContext.setSelectedConsultationType({
              value: "4",
              id: "4",
              label: "Add New Procedure",
            });
          }
          setDropdownOptions(arr);
        }
        setLoader(false);
      })
      .catch((error) => {
        C2CConsole.error(error);
      });
  }

  function handleOnChange(option) {
    if (
      (procedure_length == "5000" || procedure_length >= "5000") &&
      option.value == "4"
    ) {
      setErrorModal(true);
      myScheduleFeesContext.setSelectedConsultationType(
        dropdownOptions[dropdownOptions.length - 1]
      );
    } else {
      if (option.label === "Add New Procedure") {
        setLoader(true);
        setTimeout(() => {
          myScheduleFeesContext.setSelectedConsultationType(option);
          setLoader(false);
        });
      } else {
        myScheduleFeesContext.setSelectedConsultationType(option);
      }
    }
  }

  //function to setSlot Type
  function handleSlotType(value) {
    setSlotValue(value);
  }

  //function enable add slots button
  function handleEnableAllSLotButton(data) {
    setDisableAddBtn(data);
  }

  //function to increment counter
  function handleConsultationCounter() {
    setConsultationCounter(consultationCounter + 1);
  }
  //function to increment counter
  function handleProcedureCounter() {
    setProcedureCounter(procedureCounter + 1);
  }

  const addNewProcedureText = [
    { value: "4", id: "4", label: "Add New Procedure" },
  ];

  const Menu = (props) => {
    return (
      <>
        <components.Menu {...props}>
          <>
            <div className="all_list_options" onChange={handleOnChange}>
              {props.children}
            </div>
            {addNewProcedureText.map((addNewProcedure, index) => (
              <button
                key={index}
                className={"change-data"}
                onClick={() => handleOnChange(addNewProcedure)}
                onTouchEnd={() => handleOnChange(addNewProcedure)}
              >
                {/* Add New Procedure */}
                {addNewProcedure.label}
              </button>
            ))}
          </>
        </components.Menu>
      </>
    );
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <section>
          <div className="row px-3">
            <div className="col-lg-8 col-12 schedule-border-right px-0">
              <div className="d-flex flex-lg-row flex-column align-items-lg-center align-items-start justify-content-start mt-3 pb-4 border-bottom consult-select consult-type-dropdown px-sm-0 px-lg-3 px-0">
                <span className="mr-lg-3 mb-lg-0 mb-2 text-left font-weight-bold consult-type ">
                  {localStorage.getItem("isResourceArray") === "True" ||
                  doctorRole === USER_ROLE.RESOURCE_CONSULTANT
                    ? "Procedure : "
                    : "Consultant :"}
                </span>
                <CustomSelect
                  className="select_dropdownOptions"
                  showSearch={true}
                  placeholder=""
                  options={dropdownOptions}
                  value={myScheduleFeesContext.selectedConsultationType}
                  handleChange={handleOnChange}
                  fixedBottomBtn={true}
                  isSearchable={false}
                  fixedBtbOnChange={() =>
                    handleOnChange({
                      value: "4",
                      id: "4",
                      label: "Add New Procedure",
                      consultation_duration:
                        myScheduleFeesContext.selectedConsultationType
                          .consultation_duration,
                      common_procedure:
                        myScheduleFeesContext.selectedConsultationType
                          .common_procedure,
                    })
                  }
                />
                {doctorRole === USER_ROLE.RESOURCE_CONSULTANT &&
                  myScheduleFeesContext.selectedConsultationType
                    .common_procedure && (
                    <div className="information-box-wrapper">
                      <InformationBox title="Procedure duration and time slots will remain the same for all added procedures" />
                    </div>
                  )}
              </div>
              <div className="mt-3">
                <AddTimeRange
                  consultationType={
                    myScheduleFeesContext.selectedConsultationType
                  }
                  slotValue={slotValue}
                  handleViewSlots={handleViewSlots}
                  disableAddBtn={disableAddBtn}
                  consultationCounter={consultationCounter}
                  staffDoctor={staffDoctor}
                  handleShowDelayMarkedPopup={handleShowDelayMarkedPopup}
                  commonProcedure={commonProcedure}
                  setCommonProcedure={setCommonProcedure}
                />
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div className="row mt-3">
                <div className="col-12 px-lg-3 px-0">
                  <ConsultationSettingsContainer
                    consultationType={
                      myScheduleFeesContext.selectedConsultationType
                    }
                    onViewLogClick={(name) => {
                      if (window.innerWidth > 767) {
                        setAddClass(name);
                        props.setShowBackDrop(name);
                        props.handleViewLogOpened();
                      } else {
                        props.setShowLogsMobile(true);
                      }
                    }}
                    isResourceArray={isResourceArray}
                    getProcedure={getProcedure}
                    dropdownOptions={dropdownOptions}
                    procedure_length={procedure_length}
                    handleSlotType={handleSlotType}
                    slotValue={slotValue}
                    handleEnableAllSLotButton={handleEnableAllSLotButton}
                    handleConsultationCounter={handleConsultationCounter}
                    handleProcedureCounter={handleProcedureCounter}
                    staffDoctor={staffDoctor}
                    setCommonProcedure={setCommonProcedure}
                  />
                </div>
              </div>
            </div>
          </div>
          <MyScheduleModal
            errorModalClassName="error_modal_my_schedule"
            show={ErrorModal}
            okayClickHandler={() => setErrorModal(false)}
            name="ErrorModal"
            title="Limit Reached"
            subtitle="You can add a maximum of 5000 types of procedures. Please edit or delete the existing procedures to create a new one."
          />
          <ViewLogs
            addClass={addClass}
            setAddClass={() => {
              setAddClass("");
              props.setShowBackDrop("");
              props.handleViewLogOpened();
            }}
            logType={UPDATE_SCHEDULE}
            procedureDropDown={dropdownOptionsList}
            roleNameMenu={props.roleNameMenu}
            tableData={props.tableData}
            handleViewLogOnFilter={props?.handleViewLogOnFilter}
            logFilterData={props?.logFilterData}
            totalRecords={props?.totalRecords}
          ></ViewLogs>
        </section>
      )}
    </>
  );
}
